import React, { useState, useMemo, useEffect, useRef, useCallback } from 'react';
import { MapPin, Navigation, Heart, Home } from 'lucide-react';
import { Link } from 'react-router-dom';

// VENUE LOCATION
const VENUE = {
  name: "Conservatorio de Música de Puerto Rico",
  address: "951 PR-25, San Juan, 00907, Puerto Rico",
  lat: 18.454341,
  lng: -66.079469,
  placeId: "ChIJAX91ijBvA4wRBK_fQnbqZMk"
};

// YOUR RECOMMENDED LOCATIONS
const LOCATIONS = [
  {
    "id": 1,
    "name": "Conservatorio de M\u00fasica de Puerto Rico",
    "tags": [
      "Strongly Recommended", "Venue"

    ],
    "address": "951 PR-25, San Juan, 00907, Puerto Rico",
    "lat": 18.454341,
    "lng": -66.079469,
    "notes": "Our wedding venue! We walk Koda past this place every time we stay in San Juan. One day at a whim, we went in and asked if they do Weddings and allow dogs. To our surprise, they said yes and here we are now!",
    "placeId": "ChIJAX91ijBvA4wRBK_fQnbqZMk"
  },
  {
    "id": 2,
    "name": "El Yunque National Forest",
    "tags": [
      "Strongly Recommended", "Nature", "Hiking", "Waterfalls"

    ],
    "address": "Puerto Rico",
    "lat": 18.2951347,
    "lng": -65.8000327,
    "notes": "A large national tropical rainforest full of waterfalls, native floral/fauna, and beautiful views. Great for hiking and nature lovers",
    "placeId": "ChIJydD9LrOhBIwR0SSym7z2QoM"
  },
  {
    "id": 3,
    "name": "Playa Jobos",
    "tags": [
      "Strongly Recommended", "Beaches", "Surfing"

    ],
    "address": "Playa Jobos, Isabela 00662, Puerto Rico",
    "lat": 18.5141598,
    "lng": -67.07522759999999,
    "notes": "A great surfing beach 10 minutes away from our home that has something for beginners and advanced surfers. There are food and drink options in the shore and many restaurants nearby. A short hike takes you to the pozo de Jacinto referenced in Bad Bunny's Vueltita. Be warned, the beach boasts circular currents	that can be dangerous to inexperienced swimmers.",
    "placeId": "ChIJoWNHuMaVAowRXjr3C7yfzuQ"
  },
  {
    "id": 4,
    "name": "Jobos Mojito Beach Bar & Restaurant",
    "tags": [
      "Dining"
    ],
    "address": "PR-466 km 6.3, Jobos, Isabela 00662, Puerto Rico",
    "lat": 18.5088004,
    "lng": -67.0731144,
    "notes": "This location boasts a large selection of Mojito flavors, great grouper nuggets, and amazing views of Isabela's north coast, beaches, and boardwalks.",
    "placeId": "ChIJe8L06bCVAowRzpZQcwDAcOQ"
  },
  {
    "id": 5,
    "name": "Flamenco Beach",
    "tags": [
      "Beaches", "Snorkeling"
    ],
    "address": "Flamenco Beach, Flamenco, Culebra 00775, Puerto Rico",
    "lat": 18.3279908,
    "lng": -65.31528159999999,
    "notes": "Considered by many to be the most beautiful beach in Puerto Rico with pristine waters. Requires a short plane ride or taking a Ferry from Ceiba to Culebra.",
    "placeId": "ChIJDQjxd8boBIwRFVxA8KnucHE"
  },
  {
    "id": 6,
    "name": "Vieques",
    "tags": [
      "Beaches", "Nature", "Hiking", "Snorkeling"
    ],
    "address": "Vieques, 00765, Puerto Rico",
    "lat": 18.1485126,
    "lng": -65.44127619999999,
    "notes": "An island with many beaches and adventure options including hikes, horseback riding, and atvs. If you stay overnight you might consider going to the bioluminescent bay, although I would recommend doing so in a new moon. You want to rent a golf cart or Jeep to get around.",
    "placeId": "ChIJdem31xHHBIwRQNObP4AdLXk"
  },
  {
    "id": 7,
    "name": "Kioskos de Luquillo",
    "tags": [
      "Dining"
    ],
    "address": "97J8+CCX Kioskos de Luquillo, Luquillo, 00773, Puerto Rico",
    "lat": 18.38112,
    "lng": -65.7339052,
    "notes": "A colorful strip of many food and drink options near popular beaches on the north east side",
    "placeId": "ChIJJetjEgCZBIwRuK9PM1Yk18E"
  },
  {
    "id": 8,
    "name": "Ferry to Culebra & Vieques",
    "tags": [
      "Beaches"
    ],
    "address": "Marina Dr, Roosevelt Roads, Ceiba 00735, Puerto Rico",
    "lat": 18.2298492,
    "lng": -65.6182855,
    "notes": "Do a day trip to an island nearby!",
    "placeId": "ChIJ74PlmWW9BIwR61MXyYhK7KY"
  },
  {
    "id": 9,
    "name": "La Pen\u00faltima",
    "tags": [
      "Nightlife"
    ],
    "address": "1359 Av. de la Constituci\u00f3n, San Juan, 00907, Puerto Rico",
    "lat": 18.4486533,
    "lng": -66.07147259999999,
    "notes": "A low key bar with crafty cocktails",
    "placeId": "ChIJOdT95jVvA4wRjkdVb7BeV00"
  },
  {
    "id": 10,
    "name": "Ocean Park beach",
    "tags": [
      "Beaches"
    ],
    "address": "2170 C. Gral. Patton, San Juan, 00911, Puerto Rico",
    "lat": 18.4521581,
    "lng": -66.04785559999999,
    "notes": "Beach with a long shore, great for chilling in the sun",
    "placeId": "ChIJgwIgZ9ZvA4wRQAyaRuy0hm4"
  },
  {
    "id": 11,
    "name": "La Placita de Santurce",
    "tags": [
      "Strongly Recommended", "Nightlife", "Culture"

    ],
    "address": "300 C. dos Hermanos, San Juan, 00909, Puerto Rico",
    "lat": 18.4504555,
    "lng": -66.0705457,
    "notes": "If you heard Bad Bunny mention 'La Placita' in a song, this is what he is talking about. La Placita is renowned for its nightlife and is popping with bars, clubs, restaurants, and tons of salsa dancing.",
    "placeId": "ChIJZafB0olvA4wRbI8jAAa_pyA"
  },
  {
    "id": 12,
    "name": "Vianda",
    "tags": [
      "Dining"
    ],
    "address": "1413 PR-25, San Juan, 00907, Puerto Rico",
    "lat": 18.4479093,
    "lng": -66.0704952,
    "notes": "The sister restaurant to La Santurcina, Vianda is an upscale restaurant with a farm-to-table menu. This is where we went to right after getting engaged.",
    "placeId": "ChIJibSd8TVvA4wRSnVVJCgwE4M"
  },
  {
    "id": 13,
    "name": "Museo de Arte de Puerto Rico",
    "tags": [
      "Strongly Recommended", "Culture", "Nature"

    ],
    "address": "299 Avenida Jos\u00e9 de Diego, San Juan, 00909, Puerto Rico",
    "lat": 18.448276,
    "lng": -66.066284,
    "notes": "With 24 exhibition galleries, MAPR showcases a variety of art and sculptures. It also features a botanical garden free for entry. This garden is where we got engaged.",
    "placeId": "ChIJGYZKTeNoA4wR6HGDU33r-LU"
  },
  {
    "id": 14,
    "name": "Museo de Arte Contempor\u00e1neo de Puerto Rico",
    "tags": [
      "Culture"
    ],
    "address": "1220 Ave. Ponce de Le\u00f3n Esq. R.H. Todd Pda 18, San Juan, 00907, Puerto Rico",
    "lat": 18.4499776,
    "lng": -66.0743549,
    "notes": "Contemporary art museum with a glass roof indoor patio",
    "placeId": "ChIJ8UmF4UlvA4wRaIgdbzcVUQ0"
  },
  {
    "id": 15,
    "name": "Miramar Food Truck Park",
    "tags": [
      "Dining"
    ],
    "address": "1006 Av. de la Constituci\u00f3n, San Juan, 00907, Puerto Rico",
    "lat": 18.4531242,
    "lng": -66.07851149999999,
    "notes": "Located walking distance from the Conservatory, this food truck features poke, greek food, artisanal pizza, dumplings, mexican food, boba tea, cocktails, and ice cream. There's also James Beard semifinalist offering local cuisine. ",
    "placeId": "ChIJz8JmTYFoA4wRqik8UNdNdT8"
  },
  {
    "id": 16,
    "name": "Casita Miramar",
    "tags": [
      "Dining"
    ],
    "address": "605 Av. Miramar, San Juan, 00907, Puerto Rico",
    "lat": 18.4558229,
    "lng": -66.0851077,
    "notes": "An upscale house turned restaurant with hospitable vibes and great food. This place is a Barillas staple.",
    "placeId": "ChIJ_wl9dy9vA4wReA-OeIhk7uc"
  },
  {
    "id": 17,
    "name": "Identidad Cocktail Bar",
    "tags": [
      "Nightlife"
    ],
    "address": "962 PR-25, San Juan, 00907, Puerto Rico",
    "lat": 18.4531708,
    "lng": -66.07916519999999,
    "notes": "2025 James Beard Award Winner for Best New Bar. One of their more unique drinks uses tamarind and mushroom.",
    "placeId": "ChIJS3vDkSZvA4wRfYymtN0RNI0"
  },
  {
    "id": 18,
    "name": "La Disquera",
    "tags": [
      "Nightlife"
    ],
    "address": "610 Calle Cerra, San Juan, 00907, Puerto Rico",
    "lat": 18.4526755,
    "lng": -66.0794915,
    "notes": "A bar hidden in a nook on Calle Cerra, this photo studio turned bar offers unique cocktails and Japanese liquors. Look out for its small pink neon sign on the west side of the street after passing Peccas ice cream shop",
    "placeId": "ChIJi0gE7dFvA4wR6qKWABdjd14"
  },
  {
    "id": 19,
    "name": "Bot\u00e1nico",
    "tags": [
      "Nightlife"
    ],
    "address": "624 Calle Cerra, San Juan, 00907, Puerto Rico",
    "lat": 18.4518934,
    "lng": -66.07983589999999,
    "notes": "An open air bar with tropical funk music",
    "placeId": "ChIJpw5TDMNvA4wRDvSpOTfhOG0"
  },
  {
    "id": 20,
    "name": "Calle Cerra",
    "tags": [
      "Nightlife", "Dining"
    ],
    "address": "Calle Cerra, San Juan, 00907, Puerto Rico",
    "lat": 18.4501804,
    "lng": -66.0806431,
    "notes": "Between la Avenida Juan Ponce and Avenida las Palmas, Calle Cerra offers a wide variety of restaurants and bars",
    "placeId": "EilDYWxsZSBDZXJyYSwgU2FuIEp1YW4sIDAwOTA3LCBQdWVydG8gUmljbyIuKiwKFAoSCZurryYybwOMEZxYACufDFDtEhQKEglvGWjib2gDjBHcWpNcD39rrQ"
  },
  {
    "id": 21,
    "name": "Lote 23",
    "tags": [
      "Dining"
    ],
    "address": "1552 PR-25, San Juan, 00909, Puerto Rico",
    "lat": 18.4450632,
    "lng": -66.0671411,
    "notes": "A food truck park of the culinary incubator Jump All in! It currently offers ramen, burgers, pizza, italian food, and noodles as well as artisinal beers and quirky cocktails",
    "placeId": "ChIJM0uwAktvA4wRAdWfqS7iKD8"
  },
  {
    "id": 22,
    "name": "Pine Grove Surfing Beach",
    "tags": [
      "Beaches", "Surfing"
    ],
    "address": "Pine Grove Surfing Beach, Carolina, 00979, Puerto Rico",
    "lat": 18.4437536,
    "lng": -66.011133,
    "notes": "Beach with a long stretch of the shore, great for surfing. There are typically kiosks to rent a board.",
    "placeId": "ChIJZyz9W9BlA4wRovhNOxzcpbo"
  },
  {
    "id": 23,
    "name": "El Jibarito",
    "tags": [
      "Dining"
    ],
    "address": "280 Sol St, San Juan, 00901, Puerto Rico",
    "lat": 18.4671687,
    "lng": -66.1145386,
    "notes": "A popular casual eatery in Viejo San Juan offering local food. We highly recommend trying their bistec encebollado!",
    "placeId": "ChIJ-VQfIsFuA4wRqxvR7NUJHss"
  },
  {
    "id": 24,
    "name": "La Factor\u00eda",
    "tags": [
      "Strongly Recommended", "Nightlife"

    ],
    "address": "51 C. de San Jos\u00e9, San Juan, 00901, Puerto Rico",
    "lat": 18.4672058,
    "lng": -66.1175368,
    "notes": "A premier cocktail bar with rooms dedicated to different music genre's along with an open-air patio on the second floor. Great for chilling or dancing! 2020 James Beard Semifinalist for Outstanding Bar Program",
    "placeId": "ChIJc9aTvp5oA4wRiQJndEa2cVg"
  },
  {
    "id": 25,
    "name": "Monostereo",
    "tags": [
      "Nightlife"
    ],
    "address": "150 C. de San Sebasti\u00e1n, San Juan, 00901, Puerto Rico",
    "lat": 18.4672965,
    "lng": -66.11732450000001,
    "notes": "Bar with craft cocktails with space to lounge or dance",
    "placeId": "ChIJDZIbpMBuA4wRd5Rz3gH6dHo"
  },
  {
    "id": 26,
    "name": "Calle San Sebastian",
    "tags": [
      "Strongly Recommended", "Culture", "Nightlife"

    ],
    "address": "148 C. de San Sebasti\u00e1n, San Juan, 00901, Puerto Rico",
    "lat": 18.4673206,
    "lng": -66.11734369999999,
    "notes": "La Calle San Sebastián is one of the most iconic and lively streets in Viejo San Juan (or even Puerto Rico), lined with colorful buildings, vibrant bars, and restaurants. By day it’s rich with history and charm, and by night it transforms into the heartbeat of San Juan’s nightlife, which is a but a glimpse of its famous namesake festival.",
    "placeId": "ChIJf-bqMq9vA4wRm1usDQAYla0"
  },
  {
    "id": 27,
    "name": "El Morro",
    "tags": [
      "Strongly Recommended", "Culture"

    ],
    "address": "El Morro, San Juan, 00916, Puerto Rico",
    "lat": 18.4691202,
    "lng": -66.11669479999999,
    "notes": "A towering fortress overlooking the Atlantic Ocean in Viejo San Juan. A great location to learn about and see Puerto Rico's history and a popular spot for kite flying!",
    "placeId": "ChIJURlKecBuA4wR4nvklagZq2A"
  },
  {
    "id": 28,
    "name": "Casa BACARD\u00cd",
    "tags": [
      "Culture", "Rum"
    ],
    "address": "200 PR-165, Cata\u00f1o, 00962, Puerto Rico",
    "lat": 18.4582111,
    "lng": -66.1392645,
    "notes": "As the largest rum distillery in the world, la Casa Bacardi offers tours to showcase their history and rum making process. They also offer rum tasting and mixology sessions.",
    "placeId": "ChIJPxNJJqpuA4wR4EGhQWuDEFo"
  },
  {
    "id": 29,
    "name": "Ron del Barrilito - Hacienda Santa Ana",
    "tags": [
      "Strongly Recommended", "Culture", "Rum"

    ],
    "address": "EDMUNDO B. FERNANDEZ INC IND LUCHETTI, 490 PR-5, Bayam\u00f3n, 00961, Puerto Rico",
    "lat": 18.4138943,
    "lng": -66.1483428,
    "notes": "Home of Puerto Rico's oldest rum, Hacienda Santa Ana offers site tours, tastings, and mixology classes to showcase their two, three, four, and five star rums. Their welcome cocktails are also superb. If you decide to take a four-star bottle home, you could even bottle and seal it yourself! ",
    "placeId": "ChIJkaftC9RrA4wR3LODRcz-PYI"
  },
  {
    "id": 30,
    "name": "Guavate",
    "tags": [
      "Dining", "Culture"
    ],
    "address": "Guavate, Cayey 00736, Puerto Rico",
    "lat": 18.127953,
    "lng": -66.076093,
    "notes": "The famous pork road. Lots of lechoneras and food that tastes like christmas.",
    "placeId": "ChIJp3ajFk1OA4wR6A9V4CP2vRY"
  },
  {
    "id": 31,
    "name": "Bosque Seco de Guanica",
    "tags": [
      "Nature", "Hiking"
    ],
    "address": "X4CJ+HGV, Gu\u00e1nica 00653, Puerto Rico",
    "lat": 17.9714772,
    "lng": -66.8687099,
    "notes": "Dry forest with views of the ocean",
    "placeId": "ChIJzfcB2RwxHYwR1vI4PFu_K30"
  },
  {
    "id": 32,
    "name": "Playa Santa",
    "tags": [
      "Beaches"
    ],
    "address": "Playa Santa, Gu\u00e1nica 00647, Puerto Rico",
    "lat": 17.939757,
    "lng": -66.9566372,
    "notes": "Popular beach in the south coast of Puerto Rico",
    "placeId": "ChIJg4BoP4E3HYwRHIv9tcRILlU"
  },
  {
    "id": 33,
    "name": "Gilligans Island",
    "tags": [
      "Beaches"
    ],
    "address": "Gilligans Island, Gu\u00e1nica 00653, Puerto Rico",
    "lat": 17.9424679,
    "lng": -66.87100869999999,
    "notes": "Beautiful mangrove beach off the coast of Guanica. If you plan ahead you can schedule food delivery by boat. A short kayak away if you do not want to pay for a ferry.",
    "placeId": "ChIJuXO_tZMwHYwRLDCDel96zyg"
  },
  {
    "id": 34,
    "name": "Caja de Muertos",
    "tags": [
      "Beaches", "Hiking", "Snorkeling"
    ],
    "address": "Caja de Muertos, Ponce, Puerto Rico",
    "lat": 17.894722,
    "lng": -66.518889,
    "notes": "A beautiful beach and island off the coast of Ponce. It requires chartering a boat to get there.",
    "placeId": "ChIJ36NbpLPQHIwRBrhxfpnbLOY"
  },
  {
    "id": 35,
    "name": "The Eclipse Restaurant",
    "tags": [
      "Dining"
    ],
    "address": "10, 000 Barrio Bajuras, PR-4466, Aguacate, Aguadilla 00662, Puerto Rico",
    "lat": 18.5126974,
    "lng": -67.10319299999999,
    "notes": "An upscale hidden gem of a restaurant located at Villa Montana Resort in Isabela, right off the beach. This is a Barillas staple.",
    "placeId": "ChIJf91Mht-VAowRO1VQFgemLxc"
  },
  {
    "id": 36,
    "name": "Messalina",
    "tags": [
      "Dining"
    ],
    "address": "2 Calle San Carlos, Aguadilla, 00603, Puerto Rico",
    "lat": 18.4294776,
    "lng": -67.1551188,
    "notes": "Artisanal pizza located between the ocean shore and Aguadilla plaza",
    "placeId": "ChIJQVPiSsu9AowRKWoor4MQl2A"
  },
  {
    "id": 37,
    "name": "Crash Boat Beach",
    "tags": [
      "Beaches"
    ],
    "address": "Crash Boat Beach, Borinquen, Aguadilla 00603, Puerto Rico",
    "lat": 18.4587557,
    "lng": -67.1639648,
    "notes": "Popular beach to watch the sunset.",
    "placeId": "ChIJBa_pxxi9AowR7rJ9I-N9kr0"
  },
  {
    "id": 38,
    "name": "Rinc\u00f3n Art Walk",
    "tags": [
      "Strongly Recommended", "Culture", "Nightlife"

    ],
    "address": "4 Cll Progreso, Rinc\u00f3n, 00677, Puerto Rico",
    "lat": 18.340242,
    "lng": -67.2504909,
    "notes": "For only Thursday evenings in Rincon, this event includes live music and a large collection of artisans right in the middle of Rincon Plaza. ",
    "placeId": "ChIJY2btH5ClAowR587Tqt1f9uo"
  },
  {
    "id": 39,
    "name": "Domes Beach",
    "tags": [
      "Beaches", "Surfing"
    ],
    "address": "Domes Beach, Rinc\u00f3n, 00677, Puerto Rico",
    "lat": 18.3646675,
    "lng": -67.2699094,
    "notes": "A popular surfing beach in Rincon",
    "placeId": "ChIJ7zspgM-lAowRECC2CQaoP9s"
  },
  {
    "id": 40,
    "name": "gozalandia waterfalls",
    "tags": [
      "Nature", "Hiking", "Swimming", "Waterfalls"
    ],
    "address": "9268+5GG, San Sebasti\u00e1n, 00685, Puerto Rico",
    "lat": 18.3604375,
    "lng": -66.98367189999999,
    "notes": "Located in San Sebastian, this place has a short hike to a tall waterfall and watering hole. It also includes a longer hiking loop for those that want to spend more time in the area.",
    "placeId": "ChIJR-rELADHAowRwDH05DGJy38"
  },
  {
    "id": 41,
    "name": "Toro Verde Adventure Park",
    "tags": [
      "Strongly Recommended", "Nature", "Hiking"

    ],
    "address": "Bo Road 155, Orocovis, 00720, Puerto Rico",
    "lat": 18.2564827,
    "lng": -66.3902099,
    "notes": "This park boasts some of the longest and tallest ziplines in the world over the tropical rainforest.",
    "placeId": "ChIJ8-Rcavs6A4wRXUdnFqNqpPk"
  },
  {
    "id": 42,
    "name": "Charco Azul",
    "tags": [
      "Nature", "Swimming"
    ],
    "address": "Charco Azul, Patillas 00723, Puerto Rico",
    "lat": 18.0904215,
    "lng": -66.032646,
    "notes": "A pretty quaint and tranquil watering hole. Surprisingly blue.",
    "placeId": "ChIJYzIRi_BRA4wRInnlrIUSgEk"
  },
  {
    "id": 43,
    "name": "La Soplaera Waterfall",
    "tags": [
      "Nature", "Hiking", "Swimming", "Waterfalls"
    ],
    "address": "37W7+986, Sec Pandura, Pe\u00f1uelas 00624, Puerto Rico",
    "lat": 18.0959121,
    "lng": -66.73672510000002,
    "notes": "A waterfall located to the north of downtown Peñuelas. Highly encouraged to take a 4x4 or AWD car. Make sure to wear proper footwear and prepare to use your hands to get to the waterfall! Note: Google Maps sometimes suggests a weird route with steep hills and narrow roads, but the best way of getting there is following the signs north of downtown Penuelas.",
    "placeId": "ChIJ09enAkjTAowR2DgT5a96zdo"
  },
  {
    "id": 44,
    "name": "Ca\u00f1\u00f3n Blanco",
    "tags": [
      "Nature", "Hiking", "Swimming"
    ],
    "address": "Utuado 00641, Puerto Rico",
    "lat": 18.2276893,
    "lng": -66.6399899,
    "notes": "Beautiful hike across white rock formations and a creek.",
    "placeId": "ChIJ4ywXdbXXAowRQRp6_fPSSG8"
  },
  {
    "id": 45,
    "name": "Las Pailas",
    "tags": [
      "Nature", "Hiking", "Swimming", "Waterfalls"
    ],
    "address": "PR-983, Luquillo, 00773, Puerto Rico",
    "lat": 18.338139,
    "lng": -65.7320139,
    "notes": "A hiking trail across a creek and watering hole that boasts natural water slides. 4x4 car or AWD recommended since it requires going uphill.",
    "placeId": "ChIJ4Y0Z9-uYBIwRLBDwrG5It6s"
  },
  {
    "id": 46,
    "name": "Charco El Pil\u00f3n",
    "tags": [
      "Nature", "Hiking", "Swimming", "Waterfalls"
    ],
    "address": "42M5+HJ3, San Germ\u00e1n 00683, Puerto Rico",
    "lat": 18.133892,
    "lng": -66.9909419,
    "notes": "Located in San German, this hiking trail traverses through a stream to a beautiful waterfall. Highly encouraged to take a 4x4 or AWD car to get to the hiking trail. Wear shoes you are comfortable getting wet.",
    "placeId": "ChIJOW3J467KAowRMphsfLgntxU"
  },
  {
    "id": 47,
    "name": "Survival Beach",
    "tags": [
      "Strongly Recommended", "Beaches", "Hiking"

    ],
    "address": "14, 6 Cliff Rd, Aguadilla, 00603, Puerto Rico",
    "lat": 18.5079655,
    "lng": -67.1361469,
    "notes": "This is a two-in-one location: a surfing beach and hiking trail. The trail through the waterfront area is about 25 minutes long and ends at a secluded beach. Make sure to wear proper footwear!",
    "placeId": "ChIJ8aS83jOWAowRHJb5vndCQ5o"
  },
  {
    "id": 48,
    "name": "Paseo de la Princesa",
    "tags": [
      "Culture"
    ],
    "address": "Paseo de la Princesa, San Juan, 00901, Puerto Rico",
    "lat": 18.4642077,
    "lng": -66.1196304,
    "notes": "A beautiful promenade in Old San Juan adorned lamp posts and fountains and lined with artisans",
    "placeId": "EjJQYXNlbyBkZSBsYSBQcmluY2VzYSwgU2FuIEp1YW4sIDAwOTAxLCBQdWVydG8gUmljbyIuKiwKFAoSCYkHwWO4bgOMEbDMOvcc6BRVEhQKEglvGWjib2gDjBHcWpNcD39rrQ"
  },
  {
    "id": 49,
    "name": "El Bloque Bouldering Gym",
    "tags": [
      "Nature"
    ],
    "address": "1 Cll Chile, Ca\u00f1o Martin Pe\u00f1a, San Juan 00917, Puerto Rico",
    "lat": 18.4283999,
    "lng": -66.05612529999999,
    "notes": "Climbing Gym if you need to get a session in. The problems are graded closer to their outdoor counterparts.",
    "placeId": "ChIJAdmN_rppA4wRZX5B15aXhSE"
  },
  {
    "id": 50,
    "name": "Museo Castillo Serrall\u00e9s",
    "tags": [
      "Strongly Recommended", "Culture", "Rum"

    ],
    "address": "Sector El Vigia, P.\u00ba De La Cruceta, Ponce, 00730, Puerto Rico",
    "lat": 18.0187269,
    "lng": -66.6193047,
    "notes": "The home of Don Q Rum. This museum has a wide view of Ponce and offers tours of the building, which can include rum tasting, mixology, and learning about the distillery process and the influence the Serralles family had in Ponce.",
    "placeId": "ChIJ-yZ-63gqHYwRze80icc0_iQ"
  },
  {
    "id": 51,
    "name": "Jard\u00edn Bot\u00e1nico y Cultural William Miranda Mar\u00edn",
    "tags": [
      "Nature"
    ],
    "address": "PR-156, Caguas, 00727, Puerto Rico",
    "lat": 18.24116,
    "lng": -66.061298,
    "notes": "Botanical garden in Caguas",
    "placeId": "ChIJMedBdcdEA4wRePhuaNS0s0w"
  },
  {
    "id": 52,
    "name": "Jard\u00edn Japon\u00e9s",
    "tags": [
      "Nature"
    ],
    "address": "35-43 P.\u00ba De La Cruceta, Ponce, 00730, Puerto Rico",
    "lat": 18.0197433,
    "lng": -66.6203484,
    "notes": "A Japanese-inspired garden located right above el Castillo Serralles",
    "placeId": "ChIJMYyX5mQrHYwRhRBVoNsv7hY"
  },
  {
    "id": 53,
    "name": "Playa Do\u00f1a Lala Beach",
    "tags": [
      "Beaches"
    ],
    "address": "Playa Do\u00f1a Lala Beach, Rinc\u00f3n, 00677, Puerto Rico",
    "lat": 18.3364437,
    "lng": -67.2537574,
    "notes": "Chill beach with a long stretch of shore walking distance from Rincon Plaza",
    "placeId": "ChIJLbcG8o6lAowRl89i25tDSsU"
  },
  {
    "id": 54,
    "name": "Black Eagle Beach",
    "tags": [
      "Beaches"
    ],
    "address": "564 Black Eagle Rd, Rinc\u00f3n, 00677, Puerto Rico",
    "lat": 18.344191,
    "lng": -67.2596452,
    "notes": "Beach usually with minimal waves. Great beach for paddleboarding and sailing classes",
    "placeId": "ChIJ88rzJJOlAowRNAX_KekN9Mk"
  },
  {
    "id": 55,
    "name": "Pe\u00f1a Blanca Beach",
    "tags": [
      "Beaches"
    ],
    "address": "Unnamed Rd,, Aguadilla, 00603, Puerto Rico",
    "lat": 18.4722425,
    "lng": -67.1689469,
    "notes": "Tranquil beach outside of the beaten path. Great for sunset views if looking for something less crowded.",
    "placeId": "ChIJqzY9Dz-9AowRE2TizKb6Mk4"
  },
  {
    "id": 56,
    "name": "Playa Pocita Montones",
    "tags": [
      "Strongly Recommended", "Beaches", "Snorkeling"

    ],
    "address": "GW7P+F5F, PR-466, Isabela, 00662, Puerto Rico",
    "lat": 18.5141749,
    "lng": -67.06492399999999,
    "notes": "Beach usually with minimal waves and a natural circular rock formation full of fish. Great beach for wading and snorkeling",
    "placeId": "ChIJC-PtaMOVAowRMboJ7f3fCj0"
  },
  {
    "id": 57,
    "name": "The Beer Box",
    "tags": [
      "Dining", "Nightlife"
    ],
    "address": "KM 31.6 PR-110, Aguacate, Aguadilla 00603, Puerto Rico",
    "lat": 18.505988,
    "lng": -67.11016839999999,
    "notes": "Artisanal local draft beers and mouthwatering burgers on the 110",
    "placeId": "ChIJi_rMST2WAowRLsApf-JhHps"
  },
  {
    "id": 58,
    "name": "Timber & Blues",
    "tags": [
      "Nightlife"
    ],
    "address": "#34 C. Ramón E. Betances, Aguadilla, 00603, Puerto Rico",
    "lat": 18.4297516,
    "lng": -67.1542032,
    "notes": "Bar with speakeasy cocktails and vibes ",
    "placeId": "ChIJoWy-3ZG9AowRMSBt5ey2otg"
  },
  {
    "id": 59,
    "name": "MONA Restaurant",
    "tags": [
      "Strongly Recommended", "Dining"

    ],
    "address": "CRHW+M99, Aguadilla, 00603, Puerto Rico",
    "lat": 18.4291668,
    "lng": -67.1540095,
    "notes": "Vibrant puertorican brunch restaurant. You have to try their mofongo Benedict! ",
    "placeId": "ChIJw8sJXQC9AowR8aQlTg7o7j8"
  },
  {
    "id": 60,
    "name": "Parque de la Laguna del Condado",
    "tags": [
      "Beaches"
    ],
    "address": "860 Ashford Ave, San Juan, 00907, Puerto Rico",
    "lat": 18.4601966,
    "lng": -66.082583,
    "notes": "Hang out at the Laguna to go paddle boarding or kayaking. Or head over to the southwest corner to lounge at its beach",
    "placeId": "ChIJbTtb4gxvA4wRz0h07yx0i7Y"
  },
  {
    "id": 61,
    "name": "Campioni Pizza Birra & Tapas",
    "tags": [
      "Dining"
    ],
    "address": "42 calle isabel Esquina, Ponce, 00730, Puerto Rico",
    "lat": 18.012802,
    "lng": -66.611049,
    "notes": "Pizza restaurant with puertorican inspired flavor combinations and a staple of Fernando's childhood",
    "placeId": "ChIJZ4k1T4_VHIwR5U8wM2e0taY"
  },
  {
    "id": 62,
    "name": "CoffeeHouse",
    "tags": [
      "Dining"
    ],
    "address": "Ponce Bypass, Ponce, 00716, Puerto Rico",
    "lat": 17.9954899,
    "lng": -66.6217168,
    "notes": "Cozy cafe with great brunch and coffee",
    "placeId": "ChIJExRm0QgqHYwRt_VLHi0fxtU"
  },
  {
    "id": 63,
    "name": "Jota at Royal Isabela",
    "tags": [
      "Dining"
    ],
    "address": "Avenida Noel Estrada, Isabela, 00662, Puerto Rico",
    "lat": 18.4934582,
    "lng": -66.9898214,
    "notes": "Farm-to-table fine dining",
    "placeId": "ChIJbSP4AbfqAowRkNWz8aTfcTw"
  },
  {
    "id": 64,
    "name": "Lucas and Ella",
    "tags": [
      "Dining"
    ],
    "address": "57 Calle Agustin Stahl, Aguadilla, 00603, Puerto Rico",
    "lat": 18.434342,
    "lng": -67.1550238,
    "notes": "Dog friendly restaurant with dog-centric decor and yummy brunch",
    "placeId": "ChIJT7qZABG9AowRbPPyhff3SPk"
  },
  {
    "id": 65,
    "name": "Casita Isabela",
    "tags": [
      "Dining"
    ],
    "address": "69 Calle Jos\u00e9 A. Vargas, Isabela, 00662, Puerto Rico",
    "lat": 18.5014344,
    "lng": -67.0241842,
    "notes": "This house turned restaurant offers a variety of Puerto Rican dishes that make you feel like you're eating a grandma's house",
    "placeId": "ChIJFXQfvK6VAowReAZyWoQ-YYo"
  },
  {
    "id": 66,
    "name": "La Sirena Sushi & Tiki Bar",
    "tags": [
      "Dining"
    ],
    "address": "y Comercio, 15 Cll Uni\u00f3n, Rinc\u00f3n, 00677, Puerto Rico",
    "lat": 18.3388259,
    "lng": -67.2504479,
    "notes": "Tasty sushi and tiki drinks",
    "placeId": "ChIJHai5gB2lAowROHo_sdnjdPI"
  },
  {
    "id": 67,
    "name": "Gylro",
    "tags": [
      "Dining"
    ],
    "address": "#24 Cll Mu\u00f1oz Rivera, Rinc\u00f3n, 00677, Puerto Rico",
    "lat": 18.3391281,
    "lng": -67.2512632,
    "notes": "Tasty Greek food and unique cocktails",
    "placeId": "ChIJleA8mYylAowRMiDG9PGgn3s"
  },
  {
    "id": 68,
    "name": "La Santurcina",
    "tags": [
      "Dining"
    ],
    "address": "San Jose Towers, 1250 Av. Juan Ponce de Le\u00f3n, San Juan, 00907, Puerto Rico",
    "lat": 18.4500619,
    "lng": -66.07382869999999,
    "notes": "Artisanal pizza restaurant and our rehearsal lunch location",
    "placeId": "ChIJWSSH2JNvA4wRw2iDjAH5SHw"
  },
  {
    "id": 69,
    "name": "Pirilo Pizza Rustica - Old San Juan",
    "tags": [
      "Dining"
    ],
    "address": "207 Ca. de la Tanca, San Juan, 00901, Puerto Rico",
    "lat": 18.4655041,
    "lng": -66.1141961,
    "notes": "Rustic pizza joint",
    "placeId": "ChIJH-wXzsZuA4wRQpOy3OEMPrE"
  },
  {
    "id": 70,
    "name": "Fidela Pizza",
    "tags": [
      "Dining"
    ],
    "address": "606Av. Hip\u00f3dromo, San Juan, 00907, Puerto Rico",
    "lat": 18.4477844,
    "lng": -66.0716198,
    "notes": "Artisanal pizza joint",
    "placeId": "ChIJK8SkqyJvA4wR6Vig1nqWiqs"
  },
  {
    "id": 71,
    "name": "KEMURI Japanese Restaurant",
    "tags": [
      "Dining"
    ],
    "address": "624 Cll Ernesto Cerra, San Juan, 00907, Puerto Rico",
    "lat": 18.4516494,
    "lng": -66.07950439999999,
    "notes": "Hidden gem for Japanese curry",
    "placeId": "ChIJuwf2ADFvA4wRxqNXfhmOGUg"
  },
  {
    "id": 72,
    "name": "La P\u00edcara by Chef Xiomy",
    "tags": [
      "Dining"
    ],
    "address": "1403 Av. Juan Ponce de Le\u00f3n, San Juan, 00907, Puerto Rico",
    "lat": 18.4499211,
    "lng": -66.0730146,
    "notes": "Tasty formal dining ",
    "placeId": "ChIJ8b6iyMJvA4wRT8TORRTUquw"
  },
  {
    "id": 73,
    "name": "DISTRITO T-Mobile",
    "tags": [
      "Strongly Recommended", "Nightlife", "Dining"

    ],
    "address": "250 Convention Blvd, San Juan, 00907, Puerto Rico",
    "lat": 18.4554862,
    "lng": -66.0918045,
    "notes": "Large multi-functional area with many restaurants, bars, a DJ, an arcade, ziplining, and a VIP cinema",
    "placeId": "ChIJG64BzXpvA4wRk_rTlzmNXHM"
  },
  {
    "id": 74,
    "name": "Luc\u00eda - Patisserie+Caf\u00e9",
    "tags": [
      "Strongly Recommended", "Dining"

    ],
    "address": "857 Av. Juan Ponce de Le\u00f3n, San Juan, 00907, Puerto Rico",
    "lat": 18.4548876,
    "lng": -66.08090709999999,
    "notes": "James Beard 2025 Semi-finalist and our wedding cake vendor. Highly recommend their savory galletes",
    "placeId": "ChIJA0-7fyVvA4wRNmRsXJQMsnE"
  },
  {
    "id": 75,
    "name": "El Hipop\u00f3tamo",
    "tags": [
      "Dining"
    ],
    "address": "880 PR-1, San Juan, 00927, Puerto Rico",
    "lat": 18.4049252,
    "lng": -66.0567013,
    "notes": "Classic restaurant for classic puerto Rican food",
    "placeId": "ChIJKQB2oYVoA4wRBCy7HekiCis"
  },
  {
    "id": 76,
    "name": "Kaplash",
    "tags": [
      "Dining"
    ],
    "address": "7QWJ+PM3, PR-115, A\u00f1asco, 00610, Puerto Rico",
    "lat": 18.2967731,
    "lng": -67.2183175,
    "notes": "Casual eatery for pastelillos and a great view",
    "placeId": "ChIJ1R6Ipb6vAowROUfiXlrmH-8"
  }
];

// Dynamically generate categories from all unique tags in LOCATIONS
const CATEGORIES = (() => {
  const allTags = new Set();
  const hiddenTags = ["TODO", "Snorkeling", "Surfing"]; // Tags to hide from filter buttons

  LOCATIONS.forEach(loc => {
    if (loc.tags) {
      loc.tags.forEach(tag => {
        if (!hiddenTags.includes(tag)) {
          allTags.add(tag);
        }
      });
    }
  });
  return ["All", ...Array.from(allTags).sort()];
})();

const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 3959;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return (R * c).toFixed(1);
}

export default function ThingsToDo() {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [savedItems, setSavedItems] = useState(() => {
    // Load saved items from localStorage on initial mount
    const saved = localStorage.getItem('savedLocations');
    return saved ? new Set(JSON.parse(saved)) : new Set();
  });
  const [showSavedOnly, setShowSavedOnly] = useState(false);
  const [sortBy, setSortBy] = useState("distance");
  const [hoveredLocation, setHoveredLocation] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [placePhotos, setPlacePhotos] = useState({});  // Store photo URLs by location ID
  const mapRef = useRef(null);
  const googleMapRef = useRef(null);
  const markersRef = useRef({});
  const cardRefsRef = useRef({});
  const infoWindowRef = useRef(null);
  const hasInitializedBoundsRef = useRef(false);

  const locationsWithDistance = useMemo(() => {
    return LOCATIONS.map(loc => ({
      ...loc,
      distance: calculateDistance(VENUE.lat, VENUE.lng, loc.lat, loc.lng)
    }));
  }, []);

  const filteredLocations = useMemo(() => {
    let filtered = locationsWithDistance;

    // Hide El Bloque Bouldering Gym (id 49) from all views
    filtered = filtered.filter(loc => loc.id !== 49);

    if (selectedCategory !== "All") {
      // Filter by tags - show location if ANY tag matches selected category
      filtered = filtered.filter(loc => loc.tags.includes(selectedCategory));
    }

    if (showSavedOnly) {
      filtered = filtered.filter(loc => savedItems.has(loc.id));
    }

    if (sortBy === "distance") {
      filtered = [...filtered].sort((a, b) => parseFloat(a.distance) - parseFloat(b.distance));
    } else if (sortBy === "name") {
      filtered = [...filtered].sort((a, b) => a.name.localeCompare(b.name));
    } else if (sortBy === "category") {
      filtered = [...filtered].sort((a, b) => a.tags[0].localeCompare(b.tags[0]));
    }

    return filtered;
  }, [locationsWithDistance, selectedCategory, showSavedOnly, sortBy, savedItems]);

  const toggleSaved = (id) => {
    setSavedItems(prev => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  };

  const openDirections = (location) => {
    // Use Google Maps Directions API with Place IDs for more accurate routing
    // Note: Google requires both address and place_id parameters
    const url = `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(VENUE.address)}&origin_place_id=${VENUE.placeId}&destination=${encodeURIComponent(location.address)}&destination_place_id=${location.placeId}`;
    window.open(url, '_blank');
  };

  const loadPlacePhotos = useCallback(() => {
    if (!window.google || !window.google.maps || !window.google.maps.places) {
      console.error('Google Places API not loaded');
      return;
    }

    if (!googleMapRef.current) {
      console.error('Map not initialized');
      return;
    }

    // Create a PlacesService instance using the map
    const service = new window.google.maps.places.PlacesService(googleMapRef.current);

    // Fetch photos for each location with a small delay between requests to avoid quota issues
    LOCATIONS.forEach((location, index) => {
      if (!location.placeId) return;

      // Stagger requests to avoid overwhelming the API
      setTimeout(() => {
        const request = {
          placeId: location.placeId,
          fields: ['photos']
        };

        service.getDetails(request, (place, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK && place?.photos && place.photos.length > 0) {
            // Get the first photo and construct the URL
            const photo = place.photos[0];
            const photoUrl = photo.getUrl({ maxWidth: 800, maxHeight: 600 });

            setPlacePhotos(prev => ({
              ...prev,
              [location.id]: photoUrl
            }));
          } else if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
            console.log(`Failed to load photo for ${location.name}: ${status}`);
          }
        });
      }, index * 100); // 100ms delay between each request
    });
  }, []);

  const getCategoryColor = (category) => {
    const colors = {
      Restaurants: '#C87941',
      Bars: '#7B9EA8',
      Culture: '#B8956A',
      Nature: '#5B8C5A',
      Beaches: '#87CEEB'
    };
    return colors[category] || '#C87941';
  };

  const updateMarkers = useCallback(() => {
    if (!googleMapRef.current || !window.google || !window.google.maps || !infoWindowRef.current) return;

    // Clear existing markers
    Object.values(markersRef.current).forEach(marker => marker.setMap(null));
    markersRef.current = {};

    // Create bounds
    const bounds = new window.google.maps.LatLngBounds();
    bounds.extend({ lat: VENUE.lat, lng: VENUE.lng });

    // Custom heart shape SVG path
    const heartPath = "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z";

    // Add markers for filtered locations
    filteredLocations.forEach(location => {
      const primaryTag = location.tags[0] || "TODO";
      const categoryColor = getCategoryColor(primaryTag);

      const marker = new window.google.maps.Marker({
        position: { lat: location.lat, lng: location.lng },
        map: googleMapRef.current,
        title: location.name,
        icon: {
          path: heartPath,
          scale: 0.8,
          fillColor: "#7B9EA8", // Muted blue-gray for all non-selected pins
          fillOpacity: 1,
          strokeColor: "#ffffff",
          strokeWeight: 2,
          anchor: new window.google.maps.Point(12, 21), // Anchor at bottom of heart
        }
      });

      // Store the category color on the marker for reference
      marker.fillColor = categoryColor;

      marker.addListener('click', () => {
        setSelectedLocation(selectedLocation === location.id ? null : location.id);
      });

      marker.addListener('mouseover', () => {
        setHoveredLocation(location.id);

        if (!infoWindowRef.current) {
          console.error('InfoWindow not initialized');
          return;
        }

        // Show InfoWindow with location info
        const tags = location.tags.filter(tag => tag !== "TODO").join(", ") || "TODO";
        const content = document.createElement('div');
        content.style.padding = '8px';
        content.style.maxWidth = '200px';

        const title = document.createElement('h3');
        title.style.margin = '0 0 4px 0';
        title.style.fontWeight = '600';
        title.style.color = categoryColor;
        title.textContent = location.name;

        const info = document.createElement('p');
        info.style.margin = '0';
        info.style.fontSize = '12px';
        info.style.color = '#666';
        info.textContent = `${tags} • ${location.distance} miles`;

        content.appendChild(title);
        content.appendChild(info);

        infoWindowRef.current.setContent(content);
        // Open InfoWindow on marker hover - use classic syntax with map instance
        infoWindowRef.current.open(googleMapRef.current, marker);
      });

      marker.addListener('mouseout', () => {
        setHoveredLocation(null);
        if (infoWindowRef.current) {
          // Small delay before closing to allow smooth transition
          setTimeout(() => {
            infoWindowRef.current.close();
          }, 100);
        }
      });

      markersRef.current[location.id] = marker;
      bounds.extend({ lat: location.lat, lng: location.lng });
    });

    // Fit map to bounds on initial load or when filter changes
    if (!hasInitializedBoundsRef.current) {
      if (filteredLocations.length > 0) {
        googleMapRef.current.fitBounds(bounds);
        hasInitializedBoundsRef.current = true;
      }
    }
  }, [filteredLocations, selectedLocation]);

  // Persist saved items to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('savedLocations', JSON.stringify([...savedItems]));
  }, [savedItems]);

  // Scroll to selected card when location is selected
  useEffect(() => {
    if (selectedLocation && cardRefsRef.current[selectedLocation]) {
      cardRefsRef.current[selectedLocation].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  }, [selectedLocation]);

  // Initialize Google Maps
  useEffect(() => {
    const loadGoogleMaps = () => {
      if (window.google && window.google.maps) {
        initMap();
        return;
      }

      // Set up callback for Google Maps to call when loaded
      window.initMapCallback = initMap;

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places&callback=initMapCallback`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    };

    const initMap = () => {
      if (!mapRef.current || !window.google) return;

      const map = new window.google.maps.Map(mapRef.current, {
        center: { lat: VENUE.lat, lng: VENUE.lng },
        zoom: 8,  // Start more zoomed out, will be adjusted by fitBounds
        styles: [
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#87CEEB" }]
          },
          {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [{ color: "#F0EBE3" }]
          }
        ]
      });

      googleMapRef.current = map;

      // Create InfoWindow once during map initialization
      infoWindowRef.current = new window.google.maps.InfoWindow();

      // Add venue marker with high z-index to always stay on top
      new window.google.maps.Marker({
        position: { lat: VENUE.lat, lng: VENUE.lng },
        map: map,
        title: VENUE.name,
        icon: {
          path: window.google.maps.SymbolPath.CIRCLE,
          scale: 10,
          fillColor: "#DC2626",
          fillOpacity: 1,
          strokeColor: "#ffffff",
          strokeWeight: 2,
        },
        label: {
          text: "★",
          color: "#ffffff",
          fontSize: "14px",
          fontWeight: "bold"
        },
        zIndex: window.google.maps.Marker.MAX_ZINDEX + 100 // Keep venue always on top
      });

      // Call updateMarkers to create initial markers after map is ready
      updateMarkers();

      // Load place photos
      loadPlacePhotos();
    };

    loadGoogleMaps();
  }, [updateMarkers, loadPlacePhotos]);

  // Reset bounds when category filter changes
  useEffect(() => {
    hasInitializedBoundsRef.current = false;
  }, [selectedCategory, showSavedOnly]);

  // Update markers when filtered locations change
  useEffect(() => {
    if (googleMapRef.current) {
      updateMarkers();
    }
  }, [filteredLocations, updateMarkers]);

  // Update marker appearance when hover/selection changes (without recreating markers)
  useEffect(() => {
    if (!googleMapRef.current || !window.google) return;

    // Custom heart shape SVG path
    const heartPath = "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z";

    Object.entries(markersRef.current).forEach(([locationId, marker]) => {
      const isHovered = hoveredLocation === parseInt(locationId);
      const isSelected = selectedLocation === parseInt(locationId);
      const isActive = isHovered || isSelected;

      marker.setIcon({
        path: heartPath,
        scale: isActive ? 1.2 : 0.8, // Larger size when hovered/selected
        fillColor: isActive ? "#C87941" : "#7B9EA8", // Burnt orange when active, muted blue-gray otherwise
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 2,
        anchor: new window.google.maps.Point(12, 21), // Anchor at bottom of heart
      });

      // Bring active markers to front
      marker.setZIndex(isActive ? window.google.maps.Marker.MAX_ZINDEX + 1 : 1);
    });
  }, [hoveredLocation, selectedLocation]);

  // Zoom to selected location when a card is clicked, or zoom out when deselected
  useEffect(() => {
    if (!googleMapRef.current) return;

    if (selectedLocation) {
      // Zoom in to selected location
      const location = filteredLocations.find(loc => loc.id === selectedLocation);
      if (location) {
        googleMapRef.current.panTo({ lat: location.lat, lng: location.lng });
        googleMapRef.current.setZoom(15);
      }
    } else {
      // Zoom out to show all markers when nothing is selected
      const bounds = new window.google.maps.LatLngBounds();
      bounds.extend({ lat: VENUE.lat, lng: VENUE.lng });

      filteredLocations.forEach(location => {
        bounds.extend({ lat: location.lat, lng: location.lng });
      });

      if (filteredLocations.length > 0) {
        googleMapRef.current.fitBounds(bounds);
      }
    }
  }, [selectedLocation, filteredLocations]);

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(135deg, #FDF8F3 0%, #E8F4F8 50%, #F0EBE3 100%)' }}>
      {/* Header */}
      <div className="bg-white shadow-sm border-b" style={{ borderColor: '#C87941' }}>
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex items-start justify-between mb-2">
            <h1 className="text-3xl font-bold" style={{ color: '#C87941' }}>
              Our Favorite Spots in Puerto Rico
            </h1>
            <Link
              to="/"
              className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all hover:bg-gray-100"
              style={{ color: '#C87941' }}
            >
              <Home className="w-4 h-4" />
              Back to Home
            </Link>
          </div>
          <p className="text-gray-600 mb-1">
            Handpicked recommendations from Danielle & Fernando
          </p>
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <MapPin className="w-4 h-4" />
            <span>Distances from {VENUE.name}</span>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* Filters */}
        <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
          <div className="flex flex-wrap gap-4 items-center justify-between">
            <div className="flex flex-wrap gap-2">
              {CATEGORIES.map(cat => (
                <button
                  key={cat}
                  onClick={() => setSelectedCategory(cat)}
                  className="px-4 py-2 rounded-full text-sm font-medium transition-all"
                  style={{
                    backgroundColor: selectedCategory === cat ? '#C87941' : '#F5F5F5',
                    color: selectedCategory === cat ? 'white' : '#333'
                  }}
                >
                  {cat}
                </button>
              ))}
            </div>

            <div className="flex gap-3 items-center flex-wrap">
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2"
                style={{ borderColor: '#C87941' }}
              >
                <option value="distance">Sort by Distance</option>
                <option value="name">Sort by Name</option>
                <option value="category">Sort by Category</option>
              </select>

              <button
                onClick={() => setShowSavedOnly(!showSavedOnly)}
                className="px-4 py-2 rounded-lg text-sm font-medium transition-all flex items-center gap-2"
                style={{
                  backgroundColor: showSavedOnly ? '#FFF5EE' : '#F5F5F5',
                  color: showSavedOnly ? '#C87941' : '#333',
                  border: showSavedOnly ? '1px solid #C87941' : 'none'
                }}
              >
                <Heart className="w-4 h-4" fill={showSavedOnly ? '#C87941' : 'none'} />
                {showSavedOnly ? 'Show All' : `Saved (${savedItems.size})`}
              </button>
            </div>
          </div>
        </div>

        {/* Results count */}
        <div className="mb-4 text-sm text-gray-600">
          {filteredLocations.length} {filteredLocations.length === 1 ? 'place' : 'places'}
        </div>

        {/* Main Content: List + Map */}
        <div className="grid lg:grid-cols-2 gap-6">
          {/* Locations List */}
          <div className="space-y-4 lg:max-h-[800px] lg:overflow-y-auto lg:pr-2">
            {filteredLocations.map(location => {
              const displayTags = location.tags.filter(tag => tag !== "TODO");
              const hasValidTags = displayTags.length > 0;

              return (
                <div
                  key={location.id}
                  ref={el => cardRefsRef.current[location.id] = el}
                  className="rounded-lg transition-all border cursor-pointer overflow-hidden"
                  style={{
                    backgroundColor: selectedLocation === location.id ? '#FFF5EE' : 'white',
                    borderColor: selectedLocation === location.id ? '#C87941' : (hoveredLocation === location.id ? getCategoryColor(displayTags[0] || "TODO") : '#E5E7EB'),
                    borderWidth: selectedLocation === location.id ? '3px' : (hoveredLocation === location.id ? '2px' : '1px'),
                    boxShadow: selectedLocation === location.id ? '0 10px 25px rgba(200, 121, 65, 0.3)' : (hoveredLocation === location.id ? '0 4px 6px rgba(0, 0, 0, 0.1)' : '0 1px 3px rgba(0, 0, 0, 0.1)'),
                    transform: selectedLocation === location.id ? 'scale(1.02)' : 'scale(1)'
                  }}
                  onMouseEnter={() => setHoveredLocation(location.id)}
                  onMouseLeave={() => setHoveredLocation(null)}
                  onClick={() => setSelectedLocation(selectedLocation === location.id ? null : location.id)}
                >
                  {/* Display place photo if available */}
                  {placePhotos[location.id] && (
                    <div className="w-full h-48 overflow-hidden">
                      <img
                        src={placePhotos[location.id]}
                        alt={location.name}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          // Hide image if it fails to load
                          e.target.style.display = 'none';
                        }}
                      />
                    </div>
                  )}
                  <div className="p-5">
                    <div className="flex justify-between items-start mb-3">
                      <div className="flex-1">
                        <div className="flex items-start gap-2 mb-2">
                          <h3 className="text-lg font-semibold text-gray-900 flex-1">
                            {location.name}
                          </h3>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleSaved(location.id);
                            }}
                            className="hover:scale-110 transition-transform flex-shrink-0"
                            style={{ color: '#C87941' }}
                          >
                            <Heart
                              className="w-5 h-5"
                              fill={savedItems.has(location.id) ? '#C87941' : 'none'}
                            />
                          </button>
                        </div>
                        <div className="flex flex-wrap gap-2">
                          {hasValidTags ? (
                            displayTags.map((tag, index) => (
                              <span
                                key={index}
                                className="inline-block px-2 py-1 text-xs font-medium rounded text-white"
                                style={{ backgroundColor: getCategoryColor(tag) }}
                              >
                                {tag}
                              </span>
                            ))
                          ) : (
                            <span className="inline-block px-2 py-1 text-xs font-medium rounded bg-gray-400 text-white">
                              TODO
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    {location.notes && location.notes !== "TODO" && (
                      <div className="border-l-3 p-3 mb-3 rounded" style={{ backgroundColor: '#FFF5EE', borderLeftColor: '#C87941', borderLeftWidth: '3px' }}>
                        <p className="text-sm" style={{ color: '#8B4513' }}>
                          {location.notes}
                        </p>
                      </div>
                    )}

                    <div className="flex items-center gap-2 text-sm text-gray-600 mb-3">
                      <MapPin className="w-4 h-4 flex-shrink-0" />
                      <span>{location.distance} miles • {location.address}</span>
                    </div>

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        openDirections(location);
                      }}
                      className="w-full px-3 py-2 text-white rounded-lg text-sm font-medium transition-colors flex items-center justify-center gap-2"
                      style={{ backgroundColor: '#C87941' }}
                      onMouseOver={(e) => e.target.style.backgroundColor = '#A65F2E'}
                      onMouseOut={(e) => e.target.style.backgroundColor = '#C87941'}
                    >
                      <Navigation className="w-4 h-4" />
                      Get Directions from Venue
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Google Map */}
          <div className="lg:sticky lg:top-4 h-[600px] lg:h-[800px]">
            <div className="bg-white rounded-lg shadow-sm p-4 h-full flex flex-col">
              <h3 className="text-lg font-semibold mb-3" style={{ color: '#C87941' }}>
                Map View
              </h3>
              <div
                ref={mapRef}
                className="flex-1 rounded-lg"
                style={{ minHeight: '400px' }}
              />
              <div className="mt-3 flex flex-wrap gap-3 text-xs">
                <div className="flex items-center gap-1">
                  <div className="w-3 h-3 rounded-full" style={{ backgroundColor: '#DC2626' }}></div>
                  <span className="text-gray-600">Venue</span>
                </div>
                {CATEGORIES.filter(c => c !== 'All').map(cat => (
                  <div key={cat} className="flex items-center gap-1">
                    <div className="w-3 h-3 rounded-full" style={{ backgroundColor: getCategoryColor(cat) }}></div>
                    <span className="text-gray-600">{cat}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {filteredLocations.length === 0 && (
          <div className="text-center py-12 bg-white rounded-lg col-span-2">
            <p className="text-gray-500 text-lg">No locations match your filters.</p>
            <button
              onClick={() => {
                setSelectedCategory("All");
                setShowSavedOnly(false);
              }}
              className="mt-4 px-4 py-2 text-white rounded-lg transition-colors"
              style={{ backgroundColor: '#C87941' }}
            >
              Clear Filters
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
